<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/cdp-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">客户数据平台</h2>
							<h4 class="text-left color-white">制定更精准的市场营销策略</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">客户数据平台</h2>
				<div style="margin-top: 48px; font-size: 18px">
					客户数据平台是一款客户数据平台解决方案。它旨在帮助用户打破数据孤岛，获取第一方数据资产，并使客户数据对外部系统可用。平台专注于解决客户在市场营销、销售、客户洞察和运营效率方面的常见痛点。
				</div>
			</div>
		</div>


		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心功能</h2>
				<div style="margin-top: 48px; font-size: 18px">
					<div class="function-inner">
						<div class="edit-container">
							<ul class="clearfix">
								<li>
									<div class="block-box js-m delay1 animate">
										<div class="title">全渠道数据集成</div>
										<div class="cont">基于行业或者企业分类分级标准，通过数据资产自动扫描和数据自动识别，对企业数据资产进行分类分级，根据数据安全级别及数据访问用户权限配置。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay2 animate">
										<div class="title">动态标签管理</div>
										<div class="cont">利用预构建模型快速创建和管理标签，实现客户数据的生命周期管理。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">智能分群技术</div>
										<div class="cont">通过规则定义或文件上传，动态构建目标客户群体，优化营销策略。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">深度客户画像</div>
										<div class="cont">收集和分析客户基本信息、消费行为和偏好，提供全面的客户洞察。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">多维数据分析</div>
										<div class="cont">应用RFM、生命周期等标签，深入理解客户价值和需求。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">安全合规的数据访问</div>
										<div class="cont">通过安全的数据管理和访问控制，确保客户信息的安全性和合规性。</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">优势价值</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">数据整合能力</div>
										<div class="t2">能够处理结构化和非结构化数据，实现数据的统一视图。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">标签系统</div>
										<div class="t2">提供手动导入静态标签和根据客户行为和特征动态组合标签的能力。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">细分市场</div>
										<div class="t2">通过细分建设，使营销活动更加精准落地。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">客户洞察</div>
										<div class="t2">通过个体画像功能，深化对客户行为和偏好的理解。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">多渠道集成</div>
										<div class="t2">支持与营销自动化、DSP、内部系统、业务系统、广告平台和社交平台的多渠道集成。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">数据安全与访问控制</div>
										<div class="t2">确保数据的安全性和合规性，提供访问管理和加密传输。</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/cdp1.jpg" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'About',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.edit-container {
	position: relative;
	ul {
		margin: 0 -10px;
		display: block;
		li {
			display: inline-block;
			vertical-align: top;
			width: 33.333%;
			padding: 0 10px;
			text-align: left;
			margin-top: 15px;

			.block-box {
				padding: 34px 42px;
				position: relative;
				font-size: 16px;
				background-color: #f7f9fc;
				box-shadow: 0 10px 12px rgba(148, 160, 175, 0.33);
				border-radius: 8px;
				overflow: hidden;

				&:before {
					content: '';
					width: 100%;
					height: 6px;
					background: linear-gradient(to right, #c60c1a, #2270b2);
					position: absolute;
					left: 0;
					bottom: 0;
				}

				.title {
					font-size: 20px;
					font-weight: bold;
					height: 60px;
				}

				.cont {
					line-height: 1.8;
					height: 160px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 6;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
}

.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}

}

.swiper-container {
	width: 100%;
	height: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		margin-top: 10%;
	}
	:deep(.swiper-pagination) {
		top: 70%;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
